import axios from "axios";

const configJson = require("../config.json");
const APIBASE = new URL(configJson.apiBase);
const APIURL = APIBASE + "api/baskets";

/**
 * Request to create a basket.
 *
 * @param title The title of the new basket.
 * @param resources The documents to be added to the basket.
 * @returns {Promise<AxiosResponse<any>>}
 */
export default async function basketCreateRequest(title, resources) {
  return await axios.post(
    APIURL,
    {
      title: title,
      resources: resources
    },
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("Bearer")
      }
    }
  );
}
